import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getI18n } from 'react-i18next';
import { all } from 'q';

import { getAuthProps, loginDone } from '@topconagriculture/auth';
import { getLocale, updateUserProfile } from '@topconagriculture/profiling';

import api from '../../core/api';
import * as actions from './user.actions';
import { getApps, getUserById } from './user.actions';
import { notificationError, notificationSuccess } from '../../core/helpers/utils/notificationUtils';
import { userSelector } from '../selectors';
import { getCodeListWithDelay } from '../entities/code/code.actions';
import { boostrapApp } from '../application/bootstrap/bootstrap.actions';
import { getSettingsWithDelay } from '../entities/settings/settings.actions';

export function* getAppsSaga() {
  try {
    const { userId } = yield select(getAuthProps);
    const result = yield call(api.user.getUserApps, userId);
    yield put(
      actions.getApps.done({
        params: {},
        result,
      }),
    );
  } catch (err) {
    yield put(notificationError('common:errors.load_apps'));
  }
}

export function* getUserByIdSaga() {
  try {
    const { userId } = yield select(getAuthProps);
    yield put(actions.getUserById.started(userId));
    const result = yield call(api.user.getUserProfileById, userId);
    yield put(
      actions.getUserById.done({
        params: userId,
        result,
      }),
    );
  } catch (err) {
    yield put(notificationError('common:errors.load_user'));
  }
}

const changeLanguage = (i18nInstance: any, locale) =>
  new Promise((resolve) => {
    i18nInstance.changeLanguage(locale, resolve);
  });

export function* setLanguageSaga() {
  try {
    const lng = yield select(getLocale);
    const i18n = yield call(getI18n);
    yield call(changeLanguage, i18n, lng);
  } catch (err) {
    yield put(notificationError(`Can't set User Language.`));
  }
}

export function* updateUserSaga(action: ReturnType<typeof updateUserProfile.done>) {
  const rsn = yield select(userSelector.getRegionalSettingsName);
  const newRSN = action.payload.result.settings.regionalSettingsName;
  yield put(
    getUserById.done({
      params: action.payload.result.id,
      result: action.payload.result,
    }),
  );
  if (rsn !== newRSN) {
    yield put(notificationSuccess('settings:user_profile_unit_measure_changed'));
    yield put(getSettingsWithDelay.started());
    yield put(getCodeListWithDelay.started());
    yield put(getSettingsWithDelay.started());
  }
}

export function* watchUserSaga() {
  yield all([
    yield takeLatest(boostrapApp.done, getAppsSaga),
    yield takeLatest(getApps.started, getAppsSaga),
    yield takeLatest(loginDone, getUserByIdSaga),
    yield takeLatest(getUserById.done, setLanguageSaga),
    yield takeLatest(updateUserProfile.done, updateUserSaga),
  ]);
}
